import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TagDefinition } from '@app/models/automation/tag-definition.model';
import {Tag} from "@app/models/automation/tag";

@Injectable({ providedIn: 'root' })
export class TagDefinitionService {
  private service = 'api/tagDefinitionService';

  constructor(private httpClient: HttpClient) {}

  public getAllBySection(sectionId: number): Observable<TagDefinition[]> {
    return this.httpClient.get<TagDefinition[]>(`${this.service}/getAllBySection/${sectionId}`);
  }
  
  public getAllBySectionAndTypeWithTags(sectionId: number, typeId: number): Observable<TagDefinition[]> {
    return this.httpClient.get<TagDefinition[]>(`${this.service}/getAllBySectionAndTypeWithTags/${sectionId}/${typeId}`);
  }

  public getById(id: number): Observable<TagDefinition> {
    return this.httpClient.get<TagDefinition>(`${this.service}/getById/${id}`);
  }

  public create(tagDefinition: TagDefinition): Observable<{ id: number }> {
    return this.httpClient.post<{ id: number }>(`${this.service}/create`, tagDefinition);
  }

  public update(tagDefinition: TagDefinition): Observable<void> {
    return this.httpClient.put<void>(`${this.service}/update`, tagDefinition);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.service}/delete/${id}`);
  }

  public getTags(tagDefinitionId: number): Observable<Tag[]> {
    return this.httpClient.get<Tag[]>(`${this.service}/getTags/${tagDefinitionId}`);
  }

  public createTag(tag: Tag): Observable<Tag> {
    return this.httpClient.post<Tag>(`${this.service}/createTag`, tag);
  }

  public updateTag(tag: Tag): Observable<void> {
    return this.httpClient.put<void>(`${this.service}/updateTag`, tag);
  }

  public deleteTag(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.service}/deleteTag/${id}`);
  }
}
